import React from 'react';
import { Icon as ReactIcon } from '@a-ui/react';
import { translate } from '../../i18n';

interface NavigationToggleProps {
  isChecked?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.Ref<HTMLDivElement | null>;
}

const NavigationToggle: React.FC<NavigationToggleProps> = ({ inputRef, isChecked, onChange }) => {
  const internalRef = React.useRef<HTMLDivElement>(null);

  React.useImperativeHandle(inputRef, () => internalRef.current, []);

  return (
    <div className="a-toggle ckp-m-navigation__toggle" ref={internalRef}>
      <input
        className="a-toggle__checkbox"
        id="toggle-navigation"
        type="checkbox"
        role="switch"
        aria-checked={isChecked || false}
        checked={isChecked || false}
        onChange={onChange}
      />
      <div className="a-toggle__labels">
        {!isChecked && (
          <label htmlFor="toggle-navigation" className="a-toggle__on a-button has-icon-left">
            <ReactIcon className="m-accordion__tab__icon" name="ai-navigation-menu" />
            {translate('common.menu')}
          </label>
        )}
        {isChecked && (
          <label
            htmlFor="toggle-navigation"
            className="a-toggle__off a-button a-button--danger has-icon-left"
          >
            <ReactIcon className="m-accordion__tab__icon" name="ai-close" />
            {translate('common.menu_close')}
          </label>
        )}
      </div>
    </div>
  );
};

export default NavigationToggle;
